import { ChartType } from '@dbl/core/chart';
import { ErrorDragType } from './types';

export type TErrorDragMessageEntry = {
  text: string | string[];
  text_en: string | string[];
};

/**
 * 拖拽校验错误文案映射（含图表类型相关的复合 key）。
 */
export const ErrorDragMap: Record<string, TErrorDragMessageEntry> = {
  [ErrorDragType.Sensitive]: {
    text: '敏感字段,不便展示',
    text_en: 'Fields are sensitive and inconvenient to display',
  },
  [ErrorDragType.Custom]: {
    text: '自定义字段字符类型不支持进行过滤',
    text_en: 'Custom field character type does not support filtering',
  },
  [ErrorDragType.Same]: {
    text: '已经添加过该字段',
    text_en: 'This field has been added',
  },
  [ErrorDragType.Max]: {
    text: '最多容纳10项过滤条件',
    text_en: 'Up to 10 filter conditions can be accommodated',
  },
  [ErrorDragType.Empty]: {
    text: [
      '过滤条件, 不能为空',
      '统计指标, 不能为空',
      '分类维度为空，可能影响计算性能',
    ],
    text_en: [
      'FILTERS cannot be empty',
      'METRICS cannot be empty',
      'DIMENSIONS is empty, which may affect the calculation performance',
    ],
  },
  [`${ChartType.Trend}_dimension`]: {
    text: '该图表仅需要一个日期维度',
    text_en: 'This chart only requires one date dimension',
  },
  [`${ChartType.DimNumberTrend}_showDimension`]: {
    text: '仅支持非日期类型字段',
    text_en: 'Only non-date type fields are supported.',
  },
  [`${ChartType.DimNumberTrend}_dimensionMap_null`]: {
    text: '请配置维度内容',
    text_en: 'Please configure dimension content',
  },
};
